export default __webpack_public_path__ + "static/media/step5.5eb8ea15.png";